// Email matching and processing utilities
import { EmailMatch } from '../types';

export function getEmailMatches(message: any, leads: any[], contacts: any[], deals: any[]): EmailMatch[] {
  // This is a placeholder implementation
  // In a real implementation, this would search through leads/contacts/deals
  // to find matches based on email addresses, names, etc.

  console.log('Searching for email matches:', { messageId: message.id, leadsCount: leads.length, contactsCount: contacts.length, dealsCount: deals.length });

  // Return empty array for now
  return [];
}

export function extractFromEmail(fromHeader: string): string {
  // Extract email address from "Name <email@domain.com>" format
  const emailMatch = fromHeader.match(/<([^>]+)>/);
  if (emailMatch) {
    return emailMatch[1];
  }

  // If no angle brackets, assume it's just an email
  const simpleEmailMatch = fromHeader.match(/[^\s@]+@[^\s@]+\.[^\s@]+/);
  return simpleEmailMatch ? simpleEmailMatch[0] : fromHeader;
}

export function extractEmailAddresses(text: string): string[] {
  // Extract all email addresses from text using regex
  const emailRegex = /[^\s@]+@[^\s@]+\.[^\s@]+/g;
  const matches = text.match(emailRegex);
  return matches || [];
}

export function normalizeEmail(email: string): string {
  // Normalize email address (lowercase, trim whitespace)
  return email.toLowerCase().trim();
}

export function extractNameFromEmail(email: string): string {
  // Try to extract name from email address (e.g., "john.doe@domain.com" -> "John Doe")
  const localPart = email.split('@')[0];

  // Replace dots, underscores, etc. with spaces
  const nameWithSpaces = localPart.replace(/[\.\-_]/g, ' ');

  // Capitalize first letter of each word
  return nameWithSpaces.replace(/\b\w/g, l => l.toUpperCase());
}

export function calculateEmailMatchConfidence(
  emailAddress: string,
  leadEmail?: string,
  leadName?: string,
  leadPhone?: string
): number {
  // Calculate confidence score for email matching (0-100)

  if (!leadEmail && !leadName && !leadPhone) {
    return 0;
  }

  let confidence = 0;

  // Exact email match = high confidence
  if (leadEmail && normalizeEmail(emailAddress) === normalizeEmail(leadEmail)) {
    confidence += 80;
  }

  // Name extraction match = medium confidence
  if (leadName) {
    const extractedName = extractNameFromEmail(emailAddress);
    if (extractedName.toLowerCase().includes(leadName.toLowerCase()) ||
        leadName.toLowerCase().includes(extractedName.toLowerCase())) {
      confidence += 40;
    }
  }

  // Phone number in email (some people use phone@domain.com)
  if (leadPhone) {
    const normalizedPhone = leadPhone.replace(/\D/g, '');
    const emailLocal = emailAddress.split('@')[0];
    if (emailLocal.includes(normalizedPhone)) {
      confidence += 30;
    }
  }

  return Math.min(confidence, 100);
}